// Data hook for the global search feature (plan.md G25 — BUILD_SPEC.md §10, §13).
// Thin wrapper over hooks/useApi.ts's useApiQuery, matching every other web
// module's own convention.
import { useApiQuery } from '../../hooks/useApi';

export const SEARCH_ENTITY_KINDS = ['PRODUCT', 'SUPPLIER', 'CUSTOMER'] as const;
export type SearchEntityKind = (typeof SEARCH_ENTITY_KINDS)[number];

export interface SearchResultRow {
  kind: SearchEntityKind;
  id: string;
  code: string;
  name: string;
  score: number;
}

export interface SearchResponse {
  results: SearchResultRow[];
}

/** `GET /search?q=` (services/api/src/modules/search/search.ts) — fuzzy
 * (pg_trgm) search across products/suppliers/customers, already ranked and
 * capped server-side. Disabled while `q` is empty (mirrors the header search
 * box's own "only submit non-empty" guard, src/components/Shell.tsx). */
export function useSearch(q: string) {
  return useApiQuery<SearchResponse>(['search', q], '/search', {
    query: { q, limit: 50 },
    enabled: q.trim().length > 0,
  });
}
